import { useWarehouseStore } from '@/stores/warehouse-store';
import { useAuthStore } from '@/stores/auth-store';

export function useActiveWarehouse() {
  const { selectedWarehouseId, selectedWarehouse, isAllMode } =
    useWarehouseStore();
  const isAdmin = useAuthStore((s) => s.isAdmin());

  const effectiveAllMode = isAllMode && isAdmin;

  return {
    /** warehouseId to pass to API hooks — undefined when admin is in "All" mode */
    warehouseId: effectiveAllMode
      ? undefined
      : (selectedWarehouseId ?? undefined),
    /** Display name for current warehouse context */
    warehouseName: effectiveAllMode
      ? 'All Warehouses'
      : (selectedWarehouse?.name ?? ''),
    /** True when admin has selected "All Warehouses" */
    isAllMode: effectiveAllMode,
    /** Always the selected warehouse ID (even in All mode) — for forms that MUST have a warehouseId */
    activeWarehouseId: selectedWarehouseId,
    /** True when a form needs to show a warehouse picker (admin in All mode with no selection) */
    needsWarehouseSelection: effectiveAllMode,
  };
}
